export default __webpack_public_path__ + "static/media/money_tree.87fc5b26.jpg";